import React, { useEffect, useState } from 'react';
import api from '../../lib/api';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/ui/table';
import { toast } from 'sonner';

export default function AdminProducts() {
  const [data, setData] = useState([]);

  const load = () => api.get('/admin/products').then(r => setData(r.data.products || [])).catch(() => {});

  useEffect(() => { load(); }, []);

  const toggleStatus = async (product, nextStatus) => {
    try {
      await api.patch(`/admin/products/${product.id}`, { status: nextStatus });
      toast.success('Product updated');
      load();
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Update failed');
    }
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold text-slate-900 tracking-tight" style={{ fontFamily: 'Outfit' }}>Store Products</h1>
        <p className="text-slate-500 text-sm mt-0.5">Review products submitted by store owners.</p>
      </div>
      <Card className="bg-white border border-slate-200 shadow-sm rounded-2xl">
        <CardHeader>
          <CardTitle className="text-lg" style={{ fontFamily: 'Outfit' }}>All Products</CardTitle>
        </CardHeader>
        <CardContent className="overflow-x-auto">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Name</TableHead>
                <TableHead>Store</TableHead>
                <TableHead>Owner</TableHead>
                <TableHead>Package</TableHead>
                <TableHead>Status</TableHead>
                <TableHead>Price</TableHead>
                <TableHead>Actions</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {data.map((product) => (
                <TableRow key={product.id}>
                  <TableCell>
                    <div className="font-medium text-slate-900">{product.name}</div>
                    <div className="font-mono text-[11px] text-slate-500">{product.slug}</div>
                  </TableCell>
                  <TableCell>
                    <div className="text-sm">
                      <div className="font-medium text-slate-900">{product.store_name || '-'}</div>
                      <div className="font-mono text-[11px] text-slate-500">{product.store_username ? `shop.jjuma.com/${product.store_username}` : '-'}</div>
                    </div>
                  </TableCell>
                  <TableCell>
                    <div className="text-sm">
                      <div className="font-medium text-slate-900">{product.owner_name || '-'}</div>
                      <div className="text-xs text-slate-500">{product.owner_email || '-'}</div>
                    </div>
                  </TableCell>
                  <TableCell>{product.package?.name || '-'}</TableCell>
                  <TableCell>{product.status}</TableCell>
                  <TableCell>{product.currency} {Number(product.price || 0).toLocaleString()}</TableCell>
                  <TableCell>
                    <Button size="sm" variant="outline" onClick={() => toggleStatus(product, product.status === 'hidden' ? 'active' : 'hidden')}>
                      {product.status === 'hidden' ? 'Enable' : 'Disable'}
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  );
}
